import { compose } from 'redux'

import withErrorBoundary from 'components/shared/withErrorBoundary'
import withQueryResults from 'components/shared/withQueryResults'
import withRedux from './withRedux'
import withParams from './withParams'
import withQuery from './withQuery'
import withFormResults from 'components/shared/withFormResults'
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'

// presentational component
import UI from './UI'

// shared higher-order component
const withEditParentForm = options => {
  const { redirect } = options

  const withEditParentFormResults = withFormResults({
    mutation: 'updateParent',
    field: 'parent',
    successMessage: 'Parent/Guardian updated',
    redirect
  })

  return compose(
    withErrorBoundary,
    withRedux,
    withQueryResults,
    withParams,
    withQuery,
    withEditParentFormResults,
    withMutation,
    withEventHandlers
  )
}

// in account manager, redirect to overview
export default withEditParentForm({ redirect: '/' })(UI)

// for registration flow
export { withEditParentForm }
